import React from 'react';
export function QueVasAEncontrarSection() {
  return <section className="w-full text-center" style={{
    padding: '40px 18px',
    background: '#f5f5f5'
  }} data-id="element-125">
      {/* Título */}
      <div style={{
      fontSize: '20px',
      fontWeight: 700,
      color: '#111'
    }} data-id="element-126">
        ⚽ ¿Qué vas a encontrar dentro del Método?
      </div>

      {/* Imagen Producto */}
      <div style={{
      marginTop: '25px'
    }} data-id="element-127">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771284601/1_wlmyae.png" alt="Método ADN Campeón - Contenido del libro digital" style={{
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        maxWidth: '340px',
        borderRadius: '14px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }} data-id="element-128" />
      </div>

      {/* Tarjeta Libro Digital */}
      <div style={{
      marginTop: '25px',
      background: '#ffffff',
      padding: '22px',
      borderRadius: '16px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
      textAlign: 'left'
    }} data-id="element-129">
        {/* Etiqueta */}
        <div style={{
        display: 'inline-block',
        background: '#16a34a',
        color: '#ffffff',
        fontSize: '12px',
        fontWeight: 700,
        padding: '6px 12px',
        borderRadius: '20px',
        marginBottom: '12px'
      }} data-id="element-130">
          LIBRO DIGITAL
        </div>

        {/* Título */}
        <div style={{
        fontSize: '18px',
        fontWeight: 800,
        color: '#111',
        marginBottom: '10px'
      }} data-id="element-131">
          Método ADN CAMPEÓN
        </div>

        {/* Descripción */}
        <p style={{
        fontSize: '14px',
        color: '#4b5563',
        lineHeight: 1.6,
        marginBottom: '18px'
      }} data-id="element-132">
          La guía definitiva para desarrollar una mentalidad fuerte, competitiva
          y ganadora en tu hijo futbolista incluso si hoy se frustra, se bloquea
          o pierde la confianza.
        </p>

        {/* Puntos */}
        <div style={{
        fontSize: '14px',
        color: '#374151',
        lineHeight: 1.6,
        marginBottom: '14px'
      }} data-id="element-133">
          ✅ <strong data-id="element-134">Paso a paso claro</strong> para fortalecer su mentalidad y
          ayudarle a competir con seguridad en cada partido.
        </div>

        <div style={{
        fontSize: '14px',
        color: '#374151',
        lineHeight: 1.6,
        marginBottom: '14px'
      }} data-id="element-135">
          ✅ <strong data-id="element-136">Herramientas prácticas</strong> para que aprenda a
          gestionar errores, presión y críticas sin venirse abajo.
        </div>

        <div style={{
        fontSize: '14px',
        color: '#374151',
        lineHeight: 1.6,
        marginBottom: '14px'
      }} data-id="element-137">
          ✅{' '}
          <strong data-id="element-138">
            El método que utilizan deportistas de alto rendimiento
          </strong>{' '}
          para transformar nervios en confianza y dudas en determinación.
        </div>

        <div style={{
        fontSize: '14px',
        color: '#374151',
        lineHeight: 1.6
      }} data-id="element-139">
          ✅ <strong data-id="element-140">Estrategias probadas</strong> para que crezca dentro y
          fuera del campo desarrollando liderazgo, carácter y mentalidad de
          campeón.
        </div>
      </div>
    </section>;
}